module.exports = __webpack_public_path__ + "img/veloshop.ca_technicien_Anthony.31631938.jpg";